import { useParams } from 'react-router-dom';
// import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
// import '../assets/table.css';
import Papa from 'papaparse'
import { useEffect, useState, Fragment } from 'react';
import eventdata from "../data/events.json";
import Logos from '../components/Logos';
import Fade from 'react-reveal/Fade';

const EventPage = () => {
	let { key } = useParams();

	const [data, setData] = useState([]);
	const isTeam = eventdata[key].type === "team"

	useEffect(() => {
		Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vRPP1t7aXtfyB4ipXGiR0c0u077PlCgepfXodO5Wj7Tb4UZ95q5wjyF8VwKnGn-2V6iY16ssHBugm20/pub?gid=0&single=true&output=csv", {
			download: true,
			header: true,
			skipEmptyLines: true,
			complete: function (results) {
				setData(results.data)
			},
		})
	}, []);

	return (
		<div>
			<img className="h-40 w-full object-cover brightness-75 md:h-60" alt="event" src={eventdata[key].img_link} />
			<Fade>
				<div className="mt-14 mb-20 mx-auto w-5/6 md:w-2/3">
					<h2 className="my-6 text-5xl font-bold">{eventdata[key].title}</h2>
					{/* <p className="my-4 font-sans">{eventdata[key].desc}</p> */}
					<p className="my-4 p-2 border">Venue - <span className="font-sans">{eventdata[key].venue}</span></p>
					<p className="mt-6">Contact your respective house captains to register for this event</p>
					<h3 className="mt-8 mb-4 text-2xl font-semibold">Rules & Regulations</h3>
					{/* <p className="my-4">{eventdata[key].rules}</p> */}
					<div className='mb-4'>
						{eventdata[key].rules.map(a => <p className="text-md py-1 font-sans text-justify">• {a}</p>)}
					</div>
					<h3 className="mt-8 mb-2 text-2xl font-semibold">Participants</h3>
					<div>
						<div class={`grid w-full grid-cols-${isTeam ? "1" : "2"} text-center`}>
							{
								!isTeam ? (
									<div class="flex items-center justify-center border text-xl font-bold p-2 md:p-4">House</div>
								)
									:
									null
							}
							{isTeam ? null : <div class="border text-xl font-bold p-2 md:p-4">Participant</div>}
						</div>
						{
							data
								.filter(row => row.Event === key)
								.map((row) => {
									if (isTeam) {
										return (
											<div class="w-full mt-6 font-sans">

												<div class="border-t border-x p-2 font-semibold">{row["House"]}</div>

												<div class="border p-2 leading-8">{[...Array(eventdata[key].no_of_members)].map((e, i) => {
													return (<span>{row[`Name-${i + 1}`]} - {row[`Semester-${i + 1}`]} {row[`Department-${i + 1}`]}, </span>)
												})}</div>

											</div>
										);
									} else {
										return (
											<div class="grid w-full grid-cols-2 font-sans text-center">
												<div class="border py-2 font-semibold md:p-2">{row["House"]}</div>
												<div class="flex items-center justify-center border py-2 md:p-2">{row["Name-1"]}, {row["Semester-1"]} {row["Department-1"]}</div>
											</div>
										);
									}
								})
						}
					</div>
				</div>
			</Fade>
			<div className="w-screen box-border p-4 flex items-center overflow-hidden">
				<div className="animate-text">
					{
						[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((i) => (
							<Fragment>
								<div className="mx-6 whitespace-nowrap inline-flex items-center justify-center">‣</div>
								<div className="mx-6 whitespace-nowrap inline-flex items-center justify-center">{key}</div>
								<div className="mx-6 whitespace-nowrap inline-flex items-center justify-center">•</div>
								<div className="mx-6 whitespace-nowrap inline-flex items-center justify-center font-bold">{key}</div>
							</Fragment>
						))
					}
				</div>
			</div>
			<div className="border-y"><Logos /></div>
		</div>
	);
};

export default EventPage;
